import { MapPin, Mail, Phone } from 'lucide-react';

/**
 * ContactCard
 * Clean, responsive card grid — one card per contact channel.
 */
function ContactCard() {
  const details = [
    {
      label: 'Location',
      icon: MapPin,
      content: (
        <>
          #1, 78/6, Sarkar Chowk, Marunji, Mulshi,
          <br />
          Pune, Maharashtra – 411057
        </>
      ),
      href: 'https://www.google.com/maps/search/?api=1&query=Sarkar+Chowk+Marunji+Mulshi+Pune+411057',
      external: true,
    },
    {
      label: 'Email',
      icon: Mail,
      content: 'pvsharness@gmail.com',
      href: 'mailto:pvsharness@gmail.com',
      external: false,
    },
    {
      label: 'Mobile',
      icon: Phone,
      content: '+91-7892945169',
      href: 'tel:+917892945169',
      external: false,
    },
  ];

  return (
    <div className="w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 font-sans ">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {details.map(({ label, icon: Icon, content, href, external }) => (
          <a
            key={label}
            href={href}
            target={external ? '_blank' : undefined}
            rel={external ? 'noopener noreferrer' : undefined}
            className="group flex flex-col items-start gap-4 p-6 sm:p-8 bg-white rounded-lg border border-cogBlue/10 hover:border-cogCyan/60 transition-colors"
          >
            <span className="flex items-center justify-center w-12 h-12 rounded-full bg-cogCyan/10 text-cogCyan group-hover:bg-cogCyan group-hover:text-white transition-colors">
              <Icon className="w-5 h-5" strokeWidth={2} />
            </span>

            <div>
              <p className="text-md font-bold text-cogCyan mb-2">
                {label}
              </p>
              <p className="text-sm sm:text-base leading-relaxed text-cogBlue/80 group-hover:text-cogBlue transition-colors">
                {content}
              </p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}

export default ContactCard;